import {Fragment} from "react";
import {init as initApm} from "@elastic/apm-rum";
import packageJson from "../package.json";

export const Apm = (props) => {
  const {environment = "development"} = props;

  initApm({
    serviceName: packageJson.name,
    serverUrl: "https://apm.onemindservices.com",
    serviceVersion: packageJson.version,
    breakdownMetrics: true,
    environment: environment,
  });
  return <Fragment></Fragment>;
};
